import React from 'react';
import {MAIL_TYPE_ADD, MAIL_TYPE_FORM} from "v4/data/apiRoutes";
import FormEntityLayout from "v4/layouts/FormEntityLayout/FormEntityLayout";
import FullPageFormLayout from "v4/layouts/FullPageFormLayout/FullPageFormLayout";

export default function MailsTypesAdd() {
    return (
        <FullPageFormLayout title="add_mailing_type">
            <FormEntityLayout formRouteName={MAIL_TYPE_FORM}
                              submitRouteName={MAIL_TYPE_ADD}
                              whenSubmitted={whenSubmitted}/>
        </FullPageFormLayout>
    )
}

function whenSubmitted(history) {
    history.push(history.location.pathname.replace(/\/add$/, ''), {hasToRefresh: true});
}
